// frontend/src/components/comments/CommentsSection.tsx
import React from "react";
import { Stack, Text } from "@mantine/core";
import type { IComment } from "@backend/src/schemas";
import { CommentComposer } from "./CommentComposer";
import { CommentList } from "./CommentList";

type CommentsSectionProps = {
  title?: string;
  comments: IComment[];
  isLoading?: boolean;
  /** Inloggad användares id (string) */
  currentUserId?: string;
  isSubmitting?: boolean;
  onCreateComment: (message: string) => void | Promise<void>;
  onEditComment?: (commentId: string, newMessage: string) => void | Promise<void>;
  onDeleteComment?: (commentId: string) => void | Promise<void>;
};

export const CommentsSection: React.FC<CommentsSectionProps> = ({
  title = "Kommentarer",
  comments,
  isLoading,
  currentUserId,
  isSubmitting,
  onCreateComment,
  onEditComment,
  onDeleteComment,
}) => {
  return (
    <Stack gap="xs">
      <Text fw={500}>{title}</Text>
      <CommentList
        comments={comments}
        isLoading={isLoading}
        currentUserId={currentUserId}
        onEditComment={onEditComment}
        onDeleteComment={onDeleteComment}
      />
      <CommentComposer onSubmit={onCreateComment} isSubmitting={isSubmitting} />
    </Stack>
  );
};
